//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useForm, FormProvider} from 'react-hook-form';
import CategoryField from './CategoryField';
import {colors} from '../../../../../assets/styles/colors';
import {
  useBlogCategories,
  useBlogCategoriesAction,
} from '../../../utils/blog-category';

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    height: '100%',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textAlign: 'center',
    paddingBottom: '1rem',
    borderBottom: `1px solid ${colors.grey300}`,
    marginBottom: '.75rem',
  },
}));

type Props = {
  onSubmitSuccess: () => void,
  onSubmitError: () => void,
};

export default function EditCategories(props: Props) {
  const {onSubmitSuccess, onSubmitError} = props;
  const classes = useStyle();

  const methods = useForm();

  const {updateCategory, deleteBlogCategory} = useBlogCategoriesAction();
  const categories = useBlogCategories();

  const handleSubmit = data => {
    const promises = [];
    Object.keys(data).forEach(key => {
      const name = data[key];
      const id = key;
      if (name !== categories.find(c => c.id === id).name) {
        promises.push(updateCategory(id, {name}));
      }
    });

    Promise.all(promises)
      .then(() => {
        onSubmitSuccess();
      })
      .catch(() => {
        onSubmitError();
      });
  };

  return (
    <FormProvider {...methods}>
      <form
        className={classes.root}
        onSubmit={methods.handleSubmit(handleSubmit)}
      >
        <Typography className={classes.title}>Editar categorias</Typography>
        {categories.map(category => (
          <CategoryField
            defaultValue={category.name}
            name={category.id}
            onDelete={() => {
              deleteBlogCategory(category.id).then(() => {
                onSubmitSuccess();
              });
            }}
          />
        ))}
        <CustomButton variant="contained" type="submit">
          Guardar
        </CustomButton>
      </form>
    </FormProvider>
  );
}
